import React from 'react';
import { useAccountCashTransactions } from '@tcs/client-portal-common/hooks/useAccountTransactions';
import AccountActivityTable from '@tcs/client-portal-common/components/molecules/AccountActivityTable';

interface Props {
  accountNumber: string;
}

const AccountActivity = ({ accountNumber }: Props) => {
  const { data: transactions, loading } =
    useAccountCashTransactions(accountNumber);

  return <AccountActivityTable transactions={transactions} loading={loading} />;
};

export default AccountActivity;
